import React from 'react';
import { Link } from 'react-router-dom';

const HonestDisclosureBar: React.FC = () => {
  return (
    <section className="bg-cream-100 border-y border-warm-200">
      <div className="section-container py-4 sm:py-5">
        <Link
          to="/honestly"
          className="group flex flex-col lg:flex-row items-center justify-center gap-3 lg:gap-6 text-center lg:text-left transition-opacity duration-300 hover:opacity-90"
        >
          <div className="flex flex-col items-center lg:items-start gap-0.5 sm:gap-1">
            <span className="font-accent italic text-body text-forest-800 leading-snug">
              New site. Crypto only. We know how this looks.
            </span>
            <span className="text-caption text-warm-600 leading-snug max-w-2xl">
              The pharmacy packing your order has been around 15+ years &mdash; we&rsquo;re just the router.
            </span>
          </div>

          <span className="hidden lg:inline-block w-px h-8 bg-warm-300 flex-shrink-0" aria-hidden="true" />

          <span className="inline-flex items-center gap-1.5 text-caption font-semibold text-gold-700 uppercase tracking-[0.15em] group-hover:text-gold-600 transition-colors flex-shrink-0">
            Full story
            <svg
              className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </span>
        </Link>
      </div>
    </section>
  );
};

export default HonestDisclosureBar;
